import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './table.css';
import Translate from 'utils/translate';

class TableHeader extends Component {
  render() {
    return (
      <thead styleName="table">
        <tr>
          {this.props.headers.map((header, index) => {
            return (
              <td
                colSpan={header.colSpan ? header.colSpan : null}
                key={index}
                styleName={header.style}
              >
                {header.stringId && (
                  <Translate stringID={header.stringId} defaultValue={header.defaultString} />
                )}
              </td>
            );
          })}
        </tr>
      </thead>
    );
  }
}

TableHeader.propTypes = {
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      colSpan: PropTypes.number,
      stringId: PropTypes.string,
      defaultString: PropTypes.string,
    }).isRequired
  ).isRequired,
};
export default CSSModules(TableHeader, styles);
